import React, { useState } from 'react';
import Layout from '../../components/Layout/Layout';
import styles from './OxfordGraduationDinner.module.css';
const OxfordGraduationDinner = () => {
    const [adultTickets, setAdultTickets] = useState(0);
    const [childTickets, setChildTickets] = useState(0);
    const [adultNames, setAdultNames] = useState([]);
    const [childNames, setChildNames] = useState([]);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [dietaryRequirements, setDietaryRequirements] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const adultPrice = 110;
    const childPrice = 20;
    const total = (adultTickets * adultPrice) + (childTickets * childPrice);
    // Update names arrays when ticket count changes
    const handleAdultTicketsChange = (newCount) => {
        setAdultTickets(newCount);
        setAdultNames(prev => {
            if (newCount > prev.length) {
                return [...prev, ...Array(newCount - prev.length).fill('')];
            }
            return prev.slice(0, newCount);
        });
    };
    const handleChildTicketsChange = (newCount) => {
        setChildTickets(newCount);
        setChildNames(prev => {
            if (newCount > prev.length) {
                return [...prev, ...Array(newCount - prev.length).fill('')];
            }
            return prev.slice(0, newCount);
        });
    };
    const updateAdultName = (index, name) => {
        setAdultNames(prev => {
            const updated = [...prev];
            updated[index] = name;
            return updated;
        });
    };
    const updateChildName = (index, name) => {
        setChildNames(prev => {
            const updated = [...prev];
            updated[index] = name;
            return updated;
        });
    };
    const handleCheckout = async () => {
        if (adultTickets === 0 && childTickets === 0) {
            setError('Please select at least one ticket');
            return;
        }
        // Validate all names are filled
        const allAdultNamesFilled = adultNames.every(name => name.trim() !== '');
        const allChildNamesFilled = childNames.every(name => name.trim() !== '');
        if (!allAdultNamesFilled || !allChildNamesFilled) {
            setError('Please enter names for all attendees');
            return;
        }
        if (!email.trim()) {
            setError('Please enter your email address');
            return;
        }
        if (!phone.trim()) {
            setError('Please enter your phone number');
            return;
        }
        setIsLoading(true);
        setError('');
        try {
            const response = await fetch('/api/checkout/oxford-dinner', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    adultTickets,
                    childTickets,
                    adultNames,
                    childNames,
                    email,
                    phone,
                    dietaryRequirements
                }),
            });
            const data = await response.json();
            if (data.url) {
                window.location.href = data.url;
            }
            else {
                setError(data.error || 'Failed to create checkout session');
                setIsLoading(false);
            }
        }
        catch (err) {
            setError('Something went wrong. Please try again.');
            setIsLoading(false);
        }
    };
    return (React.createElement(Layout, { currentPath: "/events", hideHeader: true },
        React.createElement("section", { className: styles.hero, style: { backgroundImage: "url('/images/oxford-business-school.jpg')" } },
            React.createElement("div", { className: styles.heroOverlay }),
            React.createElement("div", { className: styles.heroContent },
                React.createElement("p", { className: styles.eventDate }, "Saturday, March 7th, 2026"),
                React.createElement("h1", { className: styles.heroTitle }, "Oxford Graduation Dinner"),
                React.createElement("p", { className: styles.heroSubtitle }, "Celebrating the Master's in Major Programme Management"))),
        React.createElement("section", { className: styles.details },
            React.createElement("div", { className: styles.content },
                React.createElement("div", { className: styles.detailsGrid },
                    React.createElement("div", { className: styles.detailCard },
                        React.createElement("div", { className: styles.detailIcon },
                            React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5" },
                                React.createElement("rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", ry: "2" }),
                                React.createElement("line", { x1: "16", y1: "2", x2: "16", y2: "6" }),
                                React.createElement("line", { x1: "8", y1: "2", x2: "8", y2: "6" }),
                                React.createElement("line", { x1: "3", y1: "10", x2: "21", y2: "10" }))),
                        React.createElement("h3", null, "Date"),
                        React.createElement("p", null, "Saturday, March 7th, 2026")),
                    React.createElement("div", { className: styles.detailCard },
                        React.createElement("div", { className: styles.detailIcon },
                            React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5" },
                                React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
                                React.createElement("polyline", { points: "12 6 12 12 16 14" }))),
                        React.createElement("h3", null, "Time"),
                        React.createElement("p", null, "5:00 PM onwards")),
                    React.createElement("div", { className: styles.detailCard },
                        React.createElement("div", { className: styles.detailIcon },
                            React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5" },
                                React.createElement("path", { d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" }),
                                React.createElement("circle", { cx: "12", cy: "10", r: "3" }))),
                        React.createElement("h3", null, "Venue"),
                        React.createElement("p", null,
                            "St Hilda's College",
                            React.createElement("br", null),
                            "Riverside Pavilion",
                            React.createElement("br", null),
                            "Oxford"))))),
        React.createElement("section", { className: styles.about },
            React.createElement("div", { className: styles.content },
                React.createElement("h2", null, "About the Evening"),
                React.createElement("p", null, "Join us for an elegant evening celebrating the completion of the Oxford Master's programme in Major Programme Management. This special dinner marks a significant academic achievement and provides an opportunity for graduates, family, and friends to come together in celebration."),
                React.createElement("p", null, "The evening will be held at the stunning Riverside Pavilion at St Hilda's College, offering beautiful views along the River Cherwell. The venue provides an intimate and sophisticated setting perfect for this milestone occasion."),
                React.createElement("p", { className: styles.highlight }, "We are delighted to announce there will be a surprise guest speaker."),
                React.createElement("p", { className: styles.highlight }, "Children are warmly welcome to attend."))),
        React.createElement("section", { className: styles.venue },
            React.createElement("div", { className: styles.venueImage },
                React.createElement("img", { src: "/images/st-hildas-pavilion.jpg?v=2", alt: "St Hilda's College Riverside Pavilion dining room" })),
            React.createElement("div", { className: styles.venueInfo },
                React.createElement("h2", null, "The Venue"),
                React.createElement("p", null, "St Hilda's College Riverside Pavilion is a modern architectural masterpiece situated along the banks of the River Cherwell. The light-filled space features floor-to-ceiling windows offering panoramic views of the college gardens and river, creating an unforgettable dining atmosphere."))),
        React.createElement("section", { className: styles.tickets },
            React.createElement("div", { className: styles.content },
                React.createElement("h2", null, "Tickets"),
                React.createElement("div", { className: styles.ticketOptions },
                    React.createElement("div", { className: styles.ticketOption },
                        React.createElement("div", { className: styles.ticketInfo },
                            React.createElement("h3", null, "Adult Menu"),
                            React.createElement("p", { className: styles.ticketPrice },
                                "\u00A3",
                                adultPrice)),
                        React.createElement("div", { className: styles.ticketQuantity },
                            React.createElement("button", { onClick: () => handleAdultTicketsChange(Math.max(0, adultTickets - 1)), disabled: adultTickets === 0 }, "\u2212"),
                            React.createElement("span", null, adultTickets),
                            React.createElement("button", { onClick: () => handleAdultTicketsChange(adultTickets + 1) }, "+"))),
                    React.createElement("div", { className: styles.ticketOption },
                        React.createElement("div", { className: styles.ticketInfo },
                            React.createElement("h3", null, "Children's Menu"),
                            React.createElement("p", { className: styles.ticketPrice },
                                "\u00A3",
                                childPrice)),
                        React.createElement("div", { className: styles.ticketQuantity },
                            React.createElement("button", { onClick: () => handleChildTicketsChange(Math.max(0, childTickets - 1)), disabled: childTickets === 0 }, "\u2212"),
                            React.createElement("span", null, childTickets),
                            React.createElement("button", { onClick: () => handleChildTicketsChange(childTickets + 1) }, "+")))),
                (adultTickets > 0 || childTickets > 0) && (React.createElement("div", { className: styles.checkoutSection },
                    React.createElement("div", { className: styles.attendeeNames },
                        React.createElement("h3", null, "Attendee Names"),
                        adultNames.map((name, index) => (React.createElement("div", { key: `adult-${index}`, className: styles.nameInput },
                            React.createElement("label", null,
                                "Adult ",
                                index + 1),
                            React.createElement("input", { type: "text", placeholder: "Full name", value: name, onChange: (e) => updateAdultName(index, e.target.value) })))),
                        childNames.map((name, index) => (React.createElement("div", { key: `child-${index}`, className: styles.nameInput },
                            React.createElement("label", null,
                                "Child ",
                                index + 1),
                            React.createElement("input", { type: "text", placeholder: "First name", value: name, onChange: (e) => updateChildName(index, e.target.value) }))))),
                    React.createElement("div", { className: styles.dietarySection },
                        React.createElement("label", { htmlFor: "dietary" }, "Do you have any dietary requirements or special requests?"),
                        React.createElement("textarea", { id: "dietary", placeholder: "e.g., vegetarian, gluten-free, allergies, wheelchair access...", value: dietaryRequirements, onChange: (e) => setDietaryRequirements(e.target.value), rows: 3 })),
                    React.createElement("div", { className: styles.orderSummary },
                        adultTickets > 0 && (React.createElement("p", null,
                            adultTickets,
                            " \u00D7 Adult Menu = \u00A3",
                            adultTickets * adultPrice)),
                        childTickets > 0 && (React.createElement("p", null,
                            childTickets,
                            " \u00D7 Children's Menu = \u00A3",
                            childTickets * childPrice)),
                        React.createElement("p", { className: styles.totalPrice },
                            "Total: \u00A3",
                            total)),
                    React.createElement("div", { className: styles.emailInput },
                        React.createElement("input", { type: "email", placeholder: "Email address (for confirmation)", value: email, onChange: (e) => setEmail(e.target.value) })),
                    React.createElement("div", { className: styles.phoneInput },
                        React.createElement("input", { type: "tel", placeholder: "Phone number (including country & area code, e.g. +44 1234 567890)", value: phone, onChange: (e) => setPhone(e.target.value) })),
                    error && React.createElement("p", { className: styles.error }, error),
                    React.createElement("button", { className: styles.checkoutButton, onClick: handleCheckout, disabled: isLoading }, isLoading ? 'Processing...' : `Pay £${total}`),
                    React.createElement("p", { className: styles.secureNote }, "Secure payment powered by Stripe"))))),
        React.createElement("section", { className: styles.sponsor },
            React.createElement("div", { className: styles.content },
                React.createElement("p", { className: styles.sponsorLabel }, "This event is proudly sponsored by"),
                React.createElement("p", { className: styles.sponsorName }, "Wolfeye Consulting"),
                React.createElement("a", { href: "/", className: styles.sponsorLink }, "Learn more about our work \u2192"),
                React.createElement("p", { className: styles.disclaimer }, "This is an independently organised celebration by graduating students, sponsored by Wolfeye Consulting. It is not an official event of the University of Oxford or the Sa\u00EFd Business School.")))));
};
export default OxfordGraduationDinner;
